import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import "./TabBarNav.scss";

export const TabBarNav = ({ navLabel, className, onChangeActiveTab }) => {

    const classes = classNames(
        "nav-item",
        className
    );
    return (
        <button
            className={classes}
            type="button"
            onClick={()=>{onChangeActiveTab(navLabel);}}
        >
            {navLabel}
        </button>
    );
};

TabBarNav.propTypes = {
    navLabel: PropTypes.string,
    className: PropTypes.string,
    onChangeActiveTab: PropTypes.func
};

TabBarNav.defaultProps = {
    navLabel: null,
    onChangeActiveTab: ()=>{}
};
